// extracted by mini-css-extract-plugin
module.exports = {"advertising":"Advertising_advertising__3jYOt"};